<template>
  <q-layout view="lhh LpR lff">
    <q-ajax-bar ref="bar" position="top" color="red-4" size="3px" skip-hijack></q-ajax-bar>
    <q-page-container>
      <q-page padding ref="qPage">
        <div class="row justify-between">
          <q-btn class="justify-center q-ma-xs q-pr-md" ripple dense flat color="black" to="/statistics">
            <q-icon name='arrow_left' style="font-size:2.5em"></q-icon> Quay lại
          </q-btn>
        </div>
        <q-card class="row q-my-xs">
          <div class="col-12 q-pa-md">
            <div class="text-h5 text-center q-py-md">Báo cáo nhân công làm việc tại dự án</div>
            <div class="text-h6 text-center">Ngày {{modelFrom}} - {{modelTo}}</div>
          </div>
          <div class="col-xs-12 col-sm-3 q-pa-md">
            <div class="row">
              <q-input class="col self-center" v-model="modelFrom" label="Từ ngày" readonly></q-input>
              <q-btn icon="event" size="20px" style="height: 25%" flat class="col-2 self-center">
                <q-popup-proxy>
                  <q-date v-model="modelFromDate" minimal v-close-popup='fromDatePopUp' @click="fromDatePopUp=false ; modelFrom = modelFromDate ? Moment(modelFromDate, 'YYYY/MM/DD').format('DD/MM/YYYY') : modelFrom"/>
                </q-popup-proxy>
              </q-btn>
            </div>
          </div>
          <div class="col-xs-12 col-sm-3 q-pa-md">
            <div class="row">
              <q-input clearable class="col self-center" v-model="modelTo" label="Đến ngày" readonly></q-input>
              <q-btn icon="event" size="20px" style="height: 25%" flat class="col-2 self-center">
                <q-popup-proxy>
                  <q-date v-model="modelToDate" minimal v-close-popup='toDatePopUp' @click="toDatePopUp=false ; modelTo = modelToDate ? Moment(modelToDate, 'YYYY/MM/DD').format('DD/MM/YYYY') : modelToDate"/>
                </q-popup-proxy>
              </q-btn>
              <q-btn class="col-2 self-center" ripple icon="cloud_download" flat color="black" size="20px" @click="download" :loading="isFetching"/>
            </div>
          </div>
        </q-card>

        <!-- Sum Table -->
        <div v-for="(item, key) in tables" :key="key">
          <q-table
            :title="item.title"
            :data="item.data"
            :columns="headers"
            :style="`display:${item.show ? 'block' : 'none'}`"
            row-key="name"
            no-data-label="Không có dữ liệu"
            :pagination.sync="pagination"
            :loading="isFetching"
            class="q-mb-md"
            :hide-bottom="!_.isEmpty(item.data)"
            >
            <template v-slot:top-row ="props">
              <q-tr class="text-bold text-red uppercase" v-if="!_.isEmpty(item.data)">
                <q-th>Tổng</q-th>
                <q-th class="text-center" v-for="(row,index) in _.cloneDeep(headers).slice(1)" :key="index">
                  {{row.field && row.name && row.name !== 'date' ? _.sumBy(item.data, row.name).toFixed(2): ''}}
                </q-th>
              </q-tr>
            </template>
          </q-table>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>
<script>
import {date} from 'quasar'
import moment from 'moment'
import { mapGetters } from 'vuex'
import { firebase } from '@firebase/app'
const { Timestamp } = firebase.firestore
const XlsxPopulate = require('xlsx-populate')
export default {
  name: 'DailyStatistics',
  data() {
    return {
      Moment: moment,
      tables: {
        sum: {
          title: 'Tổng',
          data: [],
          farm: 0,
          show: false
        },
      },
      headers: [
          {
            name: 'no',
            required: true,
            label: 'No',
            align: 'left',
            format: (val, row) => `${row.__index + 1}`,
            sortable: true
          },
          {
            name: 'date',
            required: true,
            sortable: true,
            label: 'Ngày',
            align: 'left',
            field: row => row.date,
            format: val => `${date.formatDate(val.toDate(), 'DD/MM/YYYY')}`,
          },
          {
            name: 'cn',
            required: true,
            sortable: true,
            label: 'Công nhật',
            align: 'center',
            field: row => row.cn,
            format: val => `${val}`,
          },
          {
            name: 'ck',
            required: true,
            sortable: true,
            label: 'Công khoán',
            align: 'center',
            field: row => row.ck,
            format: val => `${val}`,
          },
        ],
      pagination: {
        rowsPerPage: 20,
        // sortBy: 'job'
      },
      isFetching: false,
      dataFetched: [],
      toDatePopUp: false,
      fromDatePopUp: false,
      disableBtn: false,
      load: false,
      plans: null,
      tableKey: 0,
      selectedRowIndex: null,
      defaultDateFormat: 'DD/MM/YYYY',
      loading: true,
      modelFromDate: '',
      modelToDate: '',
      modelFrom: moment.utc().format('DD') <= 15 ? moment().startOf('month').format('DD/MM/YYYY') : moment(new Date(new Date().getFullYear(),new Date().getMonth(),15)).format('DD/MM/YYYY'),
      modelTo:  moment.utc().format('DD') <= 15 ? moment(new Date(new Date().getFullYear(),new Date().getMonth(),15)).format('DD/MM/YYYY') : moment().endOf('month').format('DD/MM/YYYY'),
      oldYear: null,
      oldMonth: null,
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapGetters([
      'farmStore',
      'jobStore',
      'permission'
    ])
  },
  methods: {
    async fetchData() {
      let accept = ['F1M', 'F2M', 'F3M', 'F4M', 'F5M', 'BOM']
      let vm = this
      let roles = this._.intersection(accept, Object.keys(this.permission.roles))
      if (roles.length > 0) {
        for (let i in vm.farmStore.list)
        {
          vm.tables['id'+i] = {
            title: vm.farmStore.list[i].name,
            farm: vm.farmStore.list[i].id,
            data: [],
            show: false,
          }
        }

        if (roles.indexOf('BOM') > -1) {
          for (let i in vm.tables) {
            vm.tables[i].show = true
          }
        }
        else {
          roles.forEach(r => {
            let numberPattern = /\d+/g
            let farm = r.match(numberPattern)
            vm.tables[`id${farm-1}`].show = true
          })
        }
        vm.isFetching = true
        await vm.$query(['Reports'],
        [
          ['deleted', '==', false],
          ['date','>=',Timestamp.fromDate(moment.utc(vm.modelFrom, 'DD/MM/YYYY').toDate())],
          ['date','<=',Timestamp.fromDate(moment.utc(vm.modelTo, 'DD/MM/YYYY').toDate())]
        ])
          .then((res) => {
            vm.dataFetched = res && res.data ? res.data : []
          vm.processData(vm.dataFetched)
        }).catch(error => {
          vm.$q.notify({
            message: error.toString(),
            color: 'red',
            icon: 'error'
          })
        })
        vm.isFetching = false
      } else {
        vm.disableBtn = true
        vm.$q.notify({
          message: 'You don\'t have permission',
          color: 'red',
          icon: 'error'
        })
      }
    },
    processData(resData) {
      let vm = this
        for(let i in vm.tables)
        {
          vm.tables[i].data = vm.transformData(resData, vm.tables[i])
        }
    },
    download() {
      let vm = this
      //Plans worksheet
      let col = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N']

      let colWidth = 
        //details sheet
        [10, //stt,
        30,//ngay,
        30,//cn,
        30,//ck,
        ]

      //Details worksheet
      let ext = 'xlsx'
      //Generate a file name
      let fileName = 'Bao-cao-nhan-cong-' + moment.utc(this.modelFrom, 'DD/MM/YYYY').format('DD-MM-YYYY') + '-den-' +moment.utc(this.modelTo, 'DD/MM/YYYY').format('DD-MM-YYYY')
      //generate workbook n worksheet
      XlsxPopulate.fromBlankAsync().then(workbook => {
        vm._.forEach(vm.tables, table => {
          let sheetData = [['STT','Ngày','Công nhật','Công khoán']]
            for (let i in table.data) {
              let row = [i]
              row.push(date.formatDate(table.data[i].date.toDate(), 'DD/MM/YYYY'))
              row.push(table.data[i].cn)
              row.push(table.data[i].ck)
              sheetData.push(row)
            }
              sheetData.push(['Tổng','',vm._.sumBy(table.data, 'cn'), vm._.sumBy(table.data, 'ck')])
            
            if (workbook.sheet(0).name() !== "Sheet1") {
              workbook.addSheet(table.title)
            }
            let wsLength = workbook.sheets().length-1
            workbook.sheet(wsLength).name(table.title).row(1).style("bold", true)
            workbook.sheet(wsLength).cell("A1").value(sheetData)
            for (let i in workbook.sheets()) {
              for (let j in colWidth) {
                workbook.sheets()[i].column(col[j]).width(colWidth[j])
              }
            }
        })
        return workbook.outputAsync()
        }).then(blob => {
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, `${fileName}.${ext}`)
          }
          else {
            var url = window.URL.createObjectURL(blob)
            var a = document.createElement("a")
            document.body.appendChild(a)
            a.href = url
            a.download = `${fileName}.${ext}`
            a.click()
            window.URL.revokeObjectURL(url)
            document.body.removeChild(a)
          }
        }).catch(err => {
          throw err
        })
    },
    transformData (rawData, table) {
      let data = []
      if (!table.show || !rawData || this._.isEmpty(rawData)) return []
      let resData = table.farm > 0 ? rawData.filter(item => item.farm === table.farm) : rawData
      let group = this._.groupBy(resData, 'date')
      for (let index in group) {
        let row = group[index]
        let key =  {
          date: group[index][0].date,
          cn: this._.sumBy(row.filter(item => item.worker.type === 'congnhat'), (o) => o.worker.number),
          ck: this._.sumBy(row.filter(item => item.worker.type === 'khoan'), (o) => o.worker.number)
        }
        data.push(key)
      }
      return data.sort((a,b) => b.date.seconds - a.date.seconds)
    },
  },
  watch: {
    modelTo() {
      this.toDatePopUp = true
      this.fetchData()
    },
    modelFrom() {
      this.fromDatePopUp = true
      this.fetchData()
    }
  },
}
</script>
